









import {
  HasTaskMixin, Modal, ModalMixin, AsyncBtn, notify,
} from 'mycorems-app-shared';
import { Account } from '../../types';
import accountService from '../accountService';

interface Data {
  name: string,
}

export default HasTaskMixin.extend({
  mixins: [ModalMixin],
  components: { Modal, AsyncBtn },
  props: {
    client: {
      type: Object as () => Account,
      required: true,
    },
  },
  data(): Data {
    return {
      name: this.client.name,
    };
  },
  computed: {
    title(): string {
      return `Edit - ${this.client.name}`;
    },
    canEdit(): boolean {
      return (this.client.name !== this.name);
    },
  },
  methods: {
    edit(): void {
      if (!this.canEdit) return;
      this.task = accountService.edit(this.client.id, this.name);
      this.task.then(() => {
        this.$emit('ok');
        this.$emit('hide');
        notify.success('Client edited.');
      });
    },
  },
});
